import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import { I18nMarkdown } from '../Markdown';

const Logo = ({ logo, strings }) => {
  if (get(logo, 'current')) {
    return (
      <>
        <div className="label">
          <I18nMarkdown strings={strings} string={get(logo, `list.${get(logo, 'current')}.label`, 'drawerTitle')} />
        </div>
        <div className="logo">{get(logo, `list.${get(logo, 'current')}.component`)}</div>
      </>
    );
  }
  return (
    <div className="label">
      <I18nMarkdown strings={strings} string="drawerTitle" />
    </div>
  );
};

Logo.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string).isRequired,
  logo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

Logo.defaultProps = {};

export default Logo;
